/**
 * Money formatting helpers.
 *
 * IEEE-754 doubles cannot exactly represent most decimal amounts
 * (9.9 * 3 = 29.700000000000003, 29.7 - 20 = 9.700000000000003).
 * Use these helpers wherever money is displayed or computed on the
 * client to avoid leaking that "float dust" into the UI.
 *
 *   roundMoney(v)  → number rounded to 2dp (use for client-side math)
 *   formatPrice(v) → string with exactly 2dp, safe for null/NaN
 *
 * Both treat invalid / non-finite input as 0 instead of throwing,
 * because the upstream API may return undefined for optional fields
 * (couponDiscount on an order without a coupon, etc.).
 */

export function roundMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

export function formatPrice(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0.00";
  return n.toFixed(2);
}
